import { Box, Row, Column, H3, GridContainer, BoundedContent, Typography } from '@vp/swan'
import type { MapTrackingConfig } from '../../shared/types'
import TilesList from './TilesList'

interface TilesSectionProps {
  hasBanner: boolean
  tileData: unknown[]
  leadInTitle: string
  subHeader: string
  tileImageLoadingStrategy: string
  promoCodeText: string
  tileTrackingZone: string
  useNewTiles: boolean
  locale: string
  usesMap: boolean
  mapMetadata?: MapTrackingConfig
}

const TilesSection = (props: TilesSectionProps) => {
  const { hasBanner, tileData, leadInTitle, subHeader, tileImageLoadingStrategy, promoCodeText, tileTrackingZone, useNewTiles, locale, usesMap, mapMetadata } =
    props

  return (
    <BoundedContent>
      <GridContainer>
        <Box mb="between-sections">
          {leadInTitle && (
            <Row
              data-testid="spacing"
              marginTop={!hasBanner ? 0 : 'between-sections'}
              paddingLeft={{ md: 2 }}
              marginLeft={{ xs: 4, md: 7 }}
              marginBottom={{ xs: 5, md: 6 }}
            >
              <Column span={12} padding={0}>
                {leadInTitle.trim().length > 0 && (
                  <H3 margin={0} fontSize="x2large" fontWeight="bold" fontSkin="title-section">
                    {leadInTitle}
                  </H3>
                )}
              </Column>
              {subHeader?.trim().length > 0 && leadInTitle.trim().length > 0 && (
                <Column span={12} padding={0} data-testid="subheader">
                  {/* spacing applied to here because the grid row gap prop was not matching exactly the desired spec*/}
                  <Typography fontSkin="body-standard" marginTop={{ xs: 2, md: 3 }}>
                    {subHeader}
                  </Typography>
                </Column>
              )}
            </Row>
          )}
          {tileData && (
            <Row
              marginTop={!leadInTitle ? { xs: 7, md: 9 } : {}}
              paddingLeft={{ md: 1 }}
              marginBottom={{ xs: 5, md: 0 }}
              paddingRight={{ md: 1 }}
              marginLeft={{ xs: 2, md: 6 }}
              marginRight={{ xs: 2, md: 6 }}
              component="ul"
            >
              <TilesList
                loadType={tileImageLoadingStrategy}
                list={tileData}
                promoCodeText={promoCodeText}
                trackingPageZone={tileTrackingZone}
                useNewTiles={useNewTiles}
                locale={locale}
                usesMap={usesMap}
                mapMetadata={mapMetadata}
              />
            </Row>
          )}
        </Box>
      </GridContainer>
    </BoundedContent>
  )
}

export default TilesSection
